module.exports = __webpack_public_path__ + "components/page-header/static/tide-badge-3398d10ca499e84d351b2fe2ca322a13.svg";